import { useFormik } from "formik";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  initial_values,
  validationSchema,
} from "../../../FormValidations/AccountManagementSchema";
import ChangePassword from "../../../sections/BusinessDashboard/Settings/ChangePassword";
import { AdminPageTitle } from "../../../sections/AdminDashboard/shared/adminUx";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";
import { BUSINESS_CENTERED_PAGE_TITLE_CLASS } from "../../../sections/BusinessDashboard/shared/businessLayoutSpec";

const ResetPassword = () => {
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: initial_values,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {},
  });
  return (
    <DashboardMainContainer className="lg:px-5 lg:pb-10">
      <AdminPageTitle className={`text-offblack ${BUSINESS_CENTERED_PAGE_TITLE_CLASS}`}>
        Reset password
      </AdminPageTitle>
      <div className="flex justify-center min-h-screen">
        <form onSubmit={formik.handleSubmit}>
          <ChangePassword />
        </form>
      </div>
    </DashboardMainContainer>
  );
};

export default ResetPassword;
